import { extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";

extend("email", {
	...required,
	...email,
	message: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
});

const emailWithoutSpecialChars = /^[\w.+-]+@(?!xn--)[\w.-]+(\.[A-Za-z]{2,})$/;
extend(
	"email-no-special-chars",
	(value) => emailWithoutSpecialChars.test(value) || "Bitte verwenden Sie eine E-Mail-Adresse ohne Sonderzeichen"
);

extend("password", {
	...required,
	validate: (str) => {
		const pattern = new RegExp("^.{6,64}$");
		return !!pattern.test(str);
	},
	message: "Das Passwort muss aus 6 bis 64 Zeichen bestehen.",
});
